function HourSummary({ hour, select, text, selected }) {
  let texto = text;
  const tiempo = Date.parse(text + "T00:00:00");
  if (!isNaN(tiempo)) {
    const fecha = new Date(tiempo); // Puedes pasar tu fecha específica aquí

    const opciones = {
      weekday: "short",
      day: "numeric",
      month: "short", // 'long' para nombre completo, 'short' para abreviado
    };

    texto = new Intl.DateTimeFormat("es-ES", opciones).format(fecha);
  }

  return (
    <div
      className={text === selected ? "hour-card selected" : "hour-card"}
      style={{ alignContent: "center" }}
      onClick={(e) => {
        e.preventDefault();
        select(text);
      }}
    >
      <h6 style={{ margin: 0 }}>{text === "cantidad" ? "Todo" : texto}</h6>

      <div className="hour-total">
        {hour?.cantidad ? hour?.cantidad : hour} platillos
      </div>

      {/* <p>platillos</p> */}
    </div>
  );
}

export default HourSummary;
